var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 29C22.5081 29 29 22.5081 29 14.5C29 6.49187 22.5081 0 14.5 0C6.49187 0 0 6.49187 0 14.5C0 22.5081 6.49187 29 14.5 29ZM21.6348 8.64844C22.3984 8.84766 23.0293 9.47852 23.2285 10.2754C23.627 11.6699 23.627 14.6582 23.627 14.6582C23.627 14.6582 23.627 17.6133 23.2285 19.041C23.0293 19.8379 22.3984 20.4355 21.6348 20.6348C20.207 21 14.5625 21 14.5625 21C14.5625 21 8.88477 21 7.45703 20.6348C6.69336 20.4355 6.0625 19.8379 5.86328 19.041C5.46484 17.6133 5.46484 14.6582 5.46484 14.6582C5.46484 14.6582 5.46484 11.6699 5.86328 10.2754C6.0625 9.47852 6.69336 8.84766 7.45703 8.64844C8.88477 8.25 14.5625 8.25 14.5625 8.25C14.5625 8.25 20.207 8.25 21.6348 8.64844ZM17.418 14.6582L12.7031 11.9688V17.3477L17.418 14.6582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteYoutubeLogo);
export default __webpack_public_path__ + "static/media/white-youtube-logo.f4ce736c2890407a58e7491f3cafb734.svg";
export { ForwardRef as ReactComponent };